module.exports = __webpack_public_path__ + "img/Kr-plugin-btn.5afff8f9.png";